import { render, staticRenderFns } from "./supplierDeliveryStats.vue?vue&type=template&id=a6d529d2&scoped=true&"
import script from "./supplierDeliveryStats.vue?vue&type=script&lang=js&"
export * from "./supplierDeliveryStats.vue?vue&type=script&lang=js&"
import style0 from "./supplierDeliveryStats.vue?vue&type=style&index=0&id=a6d529d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d529d2",
  null
  
)

export default component.exports